// extracted by mini-css-extract-plugin
module.exports = {"cardMeta":"TopContributors_cardMeta__CW2HQ"};